<!--
 * @Author: wankong
 * @Desc: 
 * @Date: 2021-10-10 20:13:19
 * @LastEditTime: 2021-10-18 21:57:07
-->
<template>
  <div class="Cates">
    <el-row>
      <el-col>
        <el-button type="primary" @click="addshow()">添加</el-button>
        <el-link> </el-link>
      </el-col>
    </el-row>
    <el-table :data="cateList">
      <el-table-column type="index"></el-table-column>
      <el-table-column prop="catename" label="名称"></el-table-column>
      <el-table-column prop="catedesc" label="描述"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="warning" @click="showEdit(scope.row)" icon="editor"
            >编辑</el-button
          >
          <el-button type="danger" @click="delCate(scope.row)" icon="delete"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      title="填写信息"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <el-form
        ref="caterefs"
        :rules="editRule"
        :model="cate"
        label-width="100px"
      >
        <el-form-item label="分类名称:" prop="catename">
          <el-input v-model="cate.catename" placeholder="在这里输入"></el-input>
        </el-form-item>
        <el-form-item label="描述信息：">
          <el-input v-model="cate.catedesc" placeholder="描述信息"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="changeEdit()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      cateList: [],
      cate: {},
      editRule: {
        catename: {
          required: true,
          message: "分类名要填啊。。",
          trigger: "blur",
        },
      },
    };
  },
  methods: {
    async getCateList() {
      const res = await this.$http.get(`${this.adminPre}/cate`);
      this.cateList = res.data;
    },
    // 弹窗关闭
    handleClose() {
      this.cate = {};
      this.dialogVisible = false;
    },
    showEdit(row) {
      this.cate = row;
      this.dialogVisible = true;
    },
    async delCate(row) {
      this.$confirm("此操作将永久删除该分类, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const res = await this.$http.delete(
            `${this.adminPre}/cate/${row.id}`
          );
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.getCateList();
          } else {
            this.$message({
              type: "info",
              message: "删除失败!",
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    changeEdit() {
      this.$refs["caterefs"].validate(async (valid) => {
        if (!valid) return;
        const res = await this.$http.post(`${this.adminPre}/cate`, this.cate);
        if (res.code == 200) {
          this.$message.success("成功！");
          this.dialogVisible = false;
        } else {
          this.$message.error("失败");
        }
      });
    },
    addshow() {
      this.dialogVisible = true;
    },
  },
  created() {
    this.getCateList();
  },
};
</script>

<style>
</style>